// État de navigation, reflété dans l'adresse (#…) pour que le bouton « retour » du téléphone
// et le rechargement de la page fonctionnent.
export interface Route {
  view: "list" | "search" | "settings" | "compose";
  location?: string;
  address?: string;
  q?: string;
  thread?: string;
  draft?: string;
  fresh?: string; // brouillon tout juste créé : effacé s'il est refermé sans rien y écrire
  ai?: string; // e-mail (identifiant) dont on parle avec l'assistant IA
}

export function parseRoute(hash: string): Route {
  const p = new URLSearchParams(hash.replace(/^#/, ""));
  const view = (p.get("view") as Route["view"]) || "list";
  return {
    view: ["list", "search", "settings", "compose"].includes(view) ? view : "list",
    location: p.get("location") ?? (view === "list" ? "inbox" : undefined),
    address: p.get("address") ?? undefined,
    q: p.get("q") ?? undefined,
    thread: p.get("thread") ?? undefined,
    draft: p.get("draft") ?? undefined,
    fresh: p.get("fresh") ?? undefined,
    ai: p.get("ai") ?? undefined,
  };
}

export function formatRoute(r: Route): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(r)) if (v) p.set(k, v);
  return `#${p}`;
}
